angular.module('rjmNg.directives').directive "activeRoute", [
  "$location"
  ($location) ->
    (scope, elm, attrs) ->
      pattern = new RegExp(attrs.activeRoute)
      activeClass = attrs.activeClass
      appliedClass =  if activeClass then activeClass else 'active'
      scope.$on "$routeChangeSuccess", () ->
        if pattern.test $location.path()
          elm.addClass appliedClass
        else
          elm.removeClass appliedClass
]
